class RichText extends HTMLElement {
  constructor() {
    super();
    this.iconsTitleWrapper = this.querySelector("[js-icons-title-wrapper]");
    this.iconsTitleButtons = this.querySelectorAll("[js-icons-title-button]");
    this.iconsWrappers = this.querySelectorAll("[js-icons-wrapper]");
  }

  /**
   * Remove active class from all elements in a NodeList
   * @param {NodeList} elements - The elements to remove active class from
   */
  removeActiveClass(elements) {
    elements.forEach((element) => element.classList.remove("is-active"));
  }

  /**
   * Set active tab by key
   * @param {string} key - The key attribute of the tab to activate
   * @param {Element} buttonToActivate - The button element to activate
   */
  setActiveTab(key, buttonToActivate) {
    // Remove active class from all elements
    this.removeActiveClass(this.iconsWrappers);
    this.removeActiveClass(this.iconsTitleButtons);

    // Add active class to the specified button
    if (buttonToActivate) {
      buttonToActivate.classList.add("is-active");
    }

    // Add active class to the corresponding icons wrapper
    const iconsWrapper = this.querySelector(
      `[js-icons-wrapper][data-value="${key}"]`
    );
    if (iconsWrapper) {
      iconsWrapper.classList.add("is-active");
    }
  }

  connectedCallback() {
    // Set the first button and first icons wrapper as active by default
    if (this.iconsTitleButtons.length > 0) {
      const firstButton = this.iconsTitleButtons[0];
      const firstKey = firstButton.dataset.key;
      this.setActiveTab(firstKey, firstButton);
    }

    // Add click event listener for tab switching
    this.iconsTitleWrapper.addEventListener("click", (event) => {
      if (event.target.tagName === "BUTTON") {
        const key = event.target.dataset.key;
        this.setActiveTab(key, event.target);
      }
    });
  }
}

customElements.define("rich-text", RichText);
